__turbopack_context__.v({
  "calendlyLinkBtn": "hero-module__wRcgba__calendlyLinkBtn",
  "dataPoint": "hero-module__wRcgba__dataPoint",
  "dataPoint1": "hero-module__wRcgba__dataPoint1",
  "dataPoint2": "hero-module__wRcgba__dataPoint2",
  "dataPoint3": "hero-module__wRcgba__dataPoint3",
  "float-data": "hero-module__wRcgba__float-data",
  "fluid-glow": "hero-module__wRcgba__fluid-glow",
  "glowingBackground": "hero-module__wRcgba__glowingBackground",
  "gradient-shift": "hero-module__wRcgba__gradient-shift",
  "heroCtaContainer": "hero-module__wRcgba__heroCtaContainer",
  "heroFixedContent": "hero-module__wRcgba__heroFixedContent",
  "heroHeading": "hero-module__wRcgba__heroHeading",
  "heroPrimaryCta": "hero-module__wRcgba__heroPrimaryCta",
  "heroSecondaryCta": "hero-module__wRcgba__heroSecondaryCta",
  "heroStickyWrapper": "hero-module__wRcgba__heroStickyWrapper",
  "heroSubtitle": "hero-module__wRcgba__heroSubtitle",
  "heroVisual": "hero-module__wRcgba__heroVisual",
  "isFixed": "hero-module__wRcgba__isFixed",
  "protocolVisualization": "hero-module__wRcgba__protocolVisualization",
});
